import { checkout } from "./atg-checkout";
import { AtgContactUs } from "./atg-contact-us";
import { CartCommon } from "./atg-draft-order";
import { AtgOrderConfirmation } from "./atg-order-confirmation";
import { consent } from "./consent";
import { userRegister } from "./atg-user-register";
import { atgUserManagement } from './atg-user-management';
import { atgHomepageMyOrders } from './atg-homepage-my-orders';
import { atgProduct } from './atg-product';

export const en = {
    AtgContactUs,
    AtgOrderConfirmation,
    CartCommon,
    checkout,
    consent,
    userRegister,
    atgUserManagement,
    atgHomepageMyOrders,
    atgProduct,
}